import React, { Component, Fragment } from "react";
import { Row, Col, Label, Input, FormGroup } from "reactstrap";
import { Helmet } from "react-helmet";
import axios from "axios";
import moment from "moment";
import { trackPromise } from "react-promise-tracker";
import classes from './DrivePage.module.scss';
import downloadIcon from '../../assets/icons/download.svg'
import _ from 'lodash';
import Title from "../../components/general/AdminPageTitle/AdminPageTitle";
import Table from "../../components/general/Table/Table";
import Button from "../../components/general/Button/Button";
import PaymentScheduleModal from "../../components/page/drive/PaymentScheduleModal/PaymentScheduleModal";
import Loading from "../../components/wrapper/Loading/Loading";

const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

// Exports JS array to CSV file (ty stack overflow)
function exportToCsv(filename, rows) {
    var processRow = function (row) {
        var finalVal = '';
        for (var j = 0; j < row.length; j++) {
            var innerValue = row[j] === null ? '' : row[j].toString();
            if (row[j] instanceof Date) {
                innerValue = row[j].toLocaleString();
            };
            var result = innerValue.replace(/"/g, '""');
            if (result.search(/("|,|\n)/g) >= 0)
                result = '"' + result + '"';
            if (j > 0)
                finalVal += ',';
            finalVal += result;
        }
        return finalVal + '\n';
    };

    var csvFile = '';
    for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
    }

    var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}

class PaymentsPage extends Component {
  state = {
    payments: [],
    date: null,
    paymentScheduleModalShow: false,
    paymentScheduleModalData: {},
    selectedTruckId: null,
    selectedPaymentScheduleId: null,
    isLoading: false
  };

  paymentsTableHeaders = [
    "id",
    "Vendor Name",
    "Truck Name",
    "Monthly Rate",
    "Days in Pay Period",
    "Payable Dates",
    "# Payable Days",
    "% of Days Payable",
    "Payment This Pay Period",
    "Invoice Date",
    "Pictures Received"
  ];
  paymentsTableButtons = [
    {
      display: "Edit",
      onClickHandler: async (index, id) => {
        let paymentSchedule = await this.checkPaymentSchedule(id);
        if (paymentSchedule) {
          this.setState({
            paymentScheduleModalShow: true,
            paymentScheduleModalData: paymentSchedule,
            selectedTruckId: id,
            selectedPaymentScheduleId: paymentSchedule.payment_schedule_id
          });
        } else {
        }
      }
    }
  ];

  checkPaymentSchedule = async (id) => {
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/truck/${id}/payment_schedule`, {withCredentials: true});
      if (res.status === 200 && res.data.payment_schedule && res.data.payment_schedule.length > 0) {
        return res.data.payment_schedule[0];
      }
      return false;
    } catch (err) {
      console.log(err);
    }
  };

  componentDidMount = async () => {
    let startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
    let endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
    // load payments for current month
    this.getPayments(startOfMonth, endOfMonth);
    this.setState({
      date: moment().format("YYYY-MM")
    });
  };

  formatNumber = (number) => {
    if (Number.isInteger(number)) {
      return number.toString(); // If it's an integer, display it without decimal places
    } else {
      return number.toFixed(2); // If it's a decimal, display it with one decimal place
    }
  }

  getPayments = async (start, end) => {
    try {
      this.setState({
        isLoading: true
      })
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/payment_schedule?start_date=${start}&end_date=${end}`, {withCredentials: true});
      if (res.status === 200 && res.data.payment_schedules && res.data.payment_schedules[0].vendor_id) {
        let payment_info = {
          invoice : `${moment(this.state.date).format("MMMMYYYY")}-`,
          invoiceDate : moment().format("M/D/YYYY"),
          dueDate : moment().add(1, "days").format("M/D/YYYY"),
          description : `Drivers Fees ${moment(this.state.date).format("MMMM")}`
        }
        this.setState({
          payment_info: payment_info,
        })

        let payments = res.data.payment_schedules.map((payment, index) => {
          return [
            payment.truck_id,
            payment.vendor_name,
            payment.truck_name,
            `$${payment.monthly_rate.toFixed(2)}`,
            payment.days_this_month /(60*60*24*1000),
            `${moment.utc(payment.start_active).format("M/D")} - ${moment.utc(payment.end_active).format("M/D")}`,
            this.formatNumber(payment.days_on_campaign /(60*60*24*1000)),
            `${Math.round(payment.prorate_multiplier*1000)/10 + "%"}`,
            `$${payment.amount_ext.toFixed(2)}`,
            `${moment(this.state.date).format("MMMMYYYY")}- ${index}`,
            payment.pictures_received
            //`$${payment.monthly_rate.toFixed(2)}`,
          ];
        });
        let additional_payment_data = res.data.payment_schedules.map((payment, index) => {
          return [
            payment.license_plate,
            payment.campaign_name,
            payment.start_active,
            payment.end_active,
          ];
        });

        this.setState({
          payments: payments,
          additional_payment_data: additional_payment_data,
          isLoading: false
        });
      }
    } catch (err) {
      this.setState({
        isLoading: false
      });
      console.log(err);
    }
  };

  payPeriodChangeHandler = async (e) => {
    let startOfMonth = moment(e.target.value).startOf("month").format("YYYY-MM-DD");
    let endOfMonth = moment(e.target.value).endOf("month").format("YYYY-MM-DD");
    this.getPayments(startOfMonth, endOfMonth);
    this.setState({
      date: e.target.value
    });
  };

  togglePaymentScheduleModal = () => {
    this.setState({
      paymentScheduleModalShow: false,
      paymentScheduleModalData: {},
      selectedTruckId: null,
      selectedPaymentScheduleId: null
    });
  };

  updatePaymentSchedule = async (startDate, endDate, campaignId, paymentAmount) => {
    let data = {
      campaign_id: campaignId,
      start_date: startDate,
      end_date: endDate,
      monthly_rate: paymentAmount
    };
    let res = await axios.put(
      `${process.env.REACT_APP_API_HOST}/truck/${this.state.selectedTruckId}/payment_schedule/${this.state.selectedPaymentScheduleId}`,
      data,
      config
    );
    if (res.status === 200 && res.data.updated_ps && res.data.updated_ps[0].payment_schedule_id) {
      alert("Payment schedule was updated");
      window.location.reload();
    }
  };

  deletePaymentSchedule = async () => {
    if (window.confirm(`Are you sure you want to delete this payment schedule?\nThis action is irreversible.`)) {
      let res = await axios.delete(
        `${process.env.REACT_APP_API_HOST}/payment_schedule/${this.state.selectedPaymentScheduleId}`,
        config
      );
      if (res.status === 200 && res.data.deleted_ps && res.data.deleted_ps[0].payment_schedule_id) {
        alert("Payment schedule was deleted");
        window.location.reload();
      }
    }
  };

  getMileageArray = async (truck_data) => {
    let mileages = [];
    for (const truck of truck_data){
      let res = await axios.get(
        `${process.env.REACT_APP_API_HOST}/truck/${truck.truck_id}/mileage?start_active=${truck.start_active}&end_active=${truck.end_active}`,
        { withCredentials: true } );
      if (res.status === 200 && res.data.mileage){
        mileages.push(res.data.mileage[0].total == null ? 0 : res.data.mileage[0].total);
      }
    }
    return mileages;
  };

  downloadWorkingSheet = async () => {

    let payments = _.cloneDeep(this.state.payments);
    let additional_payment_data = this.state.additional_payment_data;
    // row data
    let mileage_data_request = []
    payments.forEach((payable_truck, index) => {
      mileage_data_request.push({
        truck_id: payable_truck[0],
        start_active: additional_payment_data[index][2],
        end_active: additional_payment_data[index][3]
      });
    });
    let mileages = await trackPromise(this.getMileageArray(mileage_data_request));

    payments.forEach((payable_truck, index) => {
      payable_truck[12] = payable_truck[10]
      payable_truck[9] = this.state.additional_payment_data[index][0];
      payable_truck[10] = this.state.additional_payment_data[index][1];
      payable_truck[11] = mileages[index];
    });
    // Process working array
    let csv_array = [["Vendor Name", "Truck Name", "License Plate", "Assigned Campaign", "Payment This Period", "Mileage", "Monthly Rate", "Days in Pay Period", "Payable Dates", "# of Days Payable", "% of Days Payable", "Pictures Received"]];
    payments.map((payable_truck, index) => {
      csv_array.push([
        payable_truck[1],
        payable_truck[2],
        payable_truck[9],
        payable_truck[10],
        payable_truck[8],
        payable_truck[11],
        payable_truck[3],
        payable_truck[4],
        payable_truck[5],
        payable_truck[6],
        payable_truck[7],
        payable_truck[12],
      ]);
    });

    exportToCsv(`working_sheet.csv`, csv_array);

  };
  downloadPaymentSummaryCSV = () => {

    // To group by vendor name
    let groupBy = function(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    };

    let grouped = groupBy(this.state.payments, "1");
    let grouped_payments = Object.keys(grouped).map(function(k) { return grouped[k] });

    // row data
    let invoice = `${moment(this.state.date).format("MMMMYYYY")}-`;
    let invoiceDate = moment().format("M/D/YYYY");
    let dueDate = moment().add(1, "days").format("M/D/YYYY");
    let description = `Drivers Fees ${moment(this.state.date).format("MMMM")}`;

    // Process payments array
    let csv_array = [["Vendor Name", "Invoice #", "Invoice Date", "Due Date", "Bill Line Item Amount", "Bill Line Item Qty", "Account Name", "Description", "Bill Line Item Order"]];
    grouped_payments.map((vendor, index) => {
      //let payable_truck_count = 0;
      csv_array.push([
        vendor[0][1],
        //payable_truck_count,
        invoice + (index + 1),
        invoiceDate,
        dueDate,
        Array.from(vendor).reduce((acc, truck) => {
          //payable_truck_count += 1;
          return acc + parseFloat(truck[8].substr(1));}, 0),
        1,
        "Drivers Fees",
        description,
        1
      ]);
    });

    exportToCsv(`${invoice}invoice.csv`, csv_array);

  };

  render() {
    const buttonStyle = {
      float: "right"
    };
    return (
      <Fragment>
        <Loading loading={this.state.isLoading} label="Loading Payments..."></Loading>
        <Helmet>
          <title>Boxi Admin | Payments</title>
        </Helmet>
        <div className={`${classes.titleContainer} mb-4`}>
          <div style={{ display: "flex", alignItems: "center", columnGap: 12, flexBasis: "50%" }}>
            <div>Pay-Period</div>
            <Col>
              <Input
                type="month"
                onChange={this.payPeriodChangeHandler}
                value={this.state.date ? this.state.date : ""}
              ></Input>
            </Col>
          </div>
          <div className={classes.linksContainer}>
            <div onClick={this.downloadPaymentSummaryCSV} className={classes.linkTag}>
              Summary CSV
            </div>
            <div onClick={this.downloadWorkingSheet} className={classes.linkTag}>
              Working Sheet
            </div>
          </div>
        </div>
        <Row>
          <Col>
            <Table
              id="payments-table"
              title="Payments"
              headers={this.paymentsTableHeaders}
              buttons={this.paymentsTableButtons}
              data={this.state.payments}
            />
          </Col>
        </Row>
        <PaymentScheduleModal
          show={this.state.paymentScheduleModalShow}
          toggleModal={this.togglePaymentScheduleModal}
          data={this.state.paymentScheduleModalData}
          delete={this.deletePaymentSchedule}
          update={this.updatePaymentSchedule}
          edit
        />
      </Fragment>
    );
  }
}

export default PaymentsPage;
